import React, { Fragment, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import jwt from "jwt-decode";
import Rating from "@material-ui/lab/Rating";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import swal from "sweetalert";

function FeedbackWA() {
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };

    let query = useQuery();

    const decodeToken = (token) => {
        try {
            const decoded = jwt(token);
            if (decoded.message) return decoded;
            else return null;
        } catch (error) {
            return null;
        }
    };

    const [state, setstate] = useState({ rating: null, feedback: "", errRating: null, errFeedback: null });
    const handleChangeFeedback = (e) => {
        setstate({
            ...state,
            feedback: e.target.value,
            errFeedback: e.target.value ? null : "Please fill in your feedback.",
        });
    };

    const handleSubmit = () => {
        if (state.rating && state.feedback) {
            const reqBody = {
                rating: state.rating,
                feedback: state.feedback,
            };
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": query.get("token"),
                },
            };

            axios
                .post("/api/v1/helpdesk/whatsapp/feedback", reqBody, config)
                .then((res) => {
                    swal(res.data.message, "success", {
                        button: "OK",
                    });

                    setTimeout(function () {
                        window.location.href = "https://www.umy.ac.id/";
                    }, 3000);
                })
                .catch((err) => {
                    if (!err.response || err.code === "ECONNABORTED") {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response.data.status === "invalid") {
                        let rating = null;
                        let feedback = null;
                        err.response.data.errors.map((err) => {
                            rating = err.param === "rating" ? err.msg : rating;
                            feedback = err.param === "feedback" ? err.msg : feedback;
                        });
                        setstate({
                            errFeedback: feedback,
                            errRating: rating,
                        });
                    } else {
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                });
        } else {
            setstate({
                ...state,
                errRating: state.rating ? null : "Please give your rating.",
                errFeedback: state.feedback ? null : "Please fill in yor feedback",
            });
        }
    };

    const decode = decodeToken(query.get("token"));
    return (
        <Fragment>
            <header>
                <div className="navbar navbar bg-primary box-shadow">
                    <div className="container d-flex justify-content-between">
                        <Link to="/login" className="text-white m-3 font-weight-bolder" style={{ fontSize: "35px" }}>
                            {" "}
                            Helpdesk UMY
                        </Link>
                    </div>
                </div>
            </header>
            {decode && decode.message ? (
                <main role="main">
                    <section className=" text-center my-5">
                        <div className="container">
                            <h1 className="jumbotron-heading">Feedback</h1>
                            <p className="lead text-muted">{decode.message}</p>

                            <div className="main-content mt-5">
                                <div className="section">
                                    <div className="card card-statistic-2">
                                        <div className="card-stats">
                                            <div className="card-stats-title">
                                                <div className="card-footer chat-form container p-3" style={{ minHeight: "50px" }}>
                                                    <div className="row justify-content-md-center">
                                                        <div className="col col-lg-8 col-md-8 col-sm-12">
                                                            <div className="form-group mb-3">
                                                                <Typography component="legend">Rating</Typography>
                                                                <Rating
                                                                    style={{ fontSize: "3em" }}
                                                                    name="simple-controlled"
                                                                    value={state.rating}
                                                                    onChange={(event, newValue) => {
                                                                        setstate({ ...state, rating: newValue, errRating: newValue ? null : "Please give your rating." });
                                                                    }}
                                                                />

                                                                {state.errRating ? (
                                                                    <div>
                                                                        <small className="text-danger">{state.errRating}</small>
                                                                    </div>
                                                                ) : (
                                                                    <Fragment />
                                                                )}
                                                            </div>
                                                            <div className="form-group">
                                                                <Typography component="legend">Feedback</Typography>
                                                                <textarea
                                                                    name="feedback"
                                                                    className={`form-control ${state.errFeedback ? "is-invalid" : ""}`}
                                                                    value={state.feedback}
                                                                    style={{ height: "200px" }}
                                                                    placeholder="Type your feedback here"
                                                                    onChange={handleChangeFeedback}
                                                                ></textarea>
                                                                {state.errFeedback ? (
                                                                    <div>
                                                                        <small className="text-danger">{state.errFeedback}</small>
                                                                    </div>
                                                                ) : (
                                                                    <Fragment />
                                                                )}
                                                            </div>
                                                            <div className="form-group">
                                                                <button className="btn btn-success" style={{ textTransform: "capitalize" }} onClick={handleSubmit}>
                                                                    Submit
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            ) : (
                <Fragment />
            )}
        </Fragment>
    );
}

export default FeedbackWA;
